<template>  
<v-layout column style="position: relative;" :class="{'disable':loading }">
   <v-flex style="flex:0 0;" xs12 class="flex-container" >
        <v-card class="mx-2 mt-2" style="flex:1 0 auto;" >        
          <v-card-title class="pa-0" style="flex:0 0 auto;flex-direction:column;align-items:stretch;position:relative;height:100%;">         
            <v-layout class="px-3 pt-3 pb-0" row wrap style="flex:0 0;align-items:flex-start;border-bottom:1px solid #ccc" >
              <span class="subheading mb-1" style="flex:0 0 auto">{{$t('Pilot.Coriolis.Configuration')}}</span>
              <v-spacer />
              <v-switch hide-details class="pb-2 sm-switch" v-model="config.enableCoriolis" @change="saveConfig" :label="$t('Pilot.Coriolis.Enable')" style="flex:0 0 auto" />          
              <v-btn :title="$t('Pilot.Coriolis.InfosDownload')" class="mt-0 ml-2" small icon @click.prevent="downloadFile('/api/gliderfile/download/coriolis/template')" ><v-icon color="primary">mdi-help-circle</v-icon></v-btn>              
            </v-layout> 
            <div class="px-3 pt-2" style="flex:1 0;position:relative;"  :class="{'disable':!config.enableCoriolis}">                    
              <span class="subheading my-1" style="flex:0 0 auto">{{$t('Pilot.Coriolis.DataSync')}}</span>
              <v-layout row  class="my-2"  style="flex:0 0 auto;">
                <span style="flex:0 1 auto">{{$t('Pilot.Coriolis.AutoExport')}}</span>            
                <v-switch hide-details class="pl-2 pt-0 sm-switch" v-model="autoExportEnable" @change="saveConfig" :label="$t('Pilot.Coriolis.Enable')" style="flex:0 0 auto" />
                <v-spacer />          
                <div style="text-align: right;margin-top: -30px;">
                  {{ $t('Pilot.Coriolis.LastExport') }} : {{ config.Coriolis_Export.last_export }}<br/>
                  <v-btn class="mb-2 mr-0" @click.prevent="run" :disabled="btnRunDisable" small>{{$t('Pilot.Coriolis.Run')}}<v-icon small right>mdi-play</v-icon></v-btn>
                </div>                              
              </v-layout>                          
            </div>
            <!-- <v-layout class="pt-0" row wrap style="flex:0 0;align-items:flex-start;" >
              <v-spacer />          
              <v-btn @click.prevent="restoreConfig" :disabled="!btnActif" small>{{$t('Pilot.Coriolis.RestoreConfig')}}<v-icon small right>mdi-replay</v-icon></v-btn>
              <v-btn @click.prevent="saveConfig" :disabled="!btnActif" small color="primary">{{$t('Pilot.Coriolis.ValidateConfig')}}<v-icon small right >mdi-content-save</v-icon></v-btn>
            </v-layout> -->
          </v-card-title>   
      </v-card>   
    </v-flex>   
    <mission-detail-file-upload filterCurrentMission :coriolis="true"  :fileList="fileList" @download="downloadCoriolisFile" @uploaded="uploaded" @allUploaded="allUploaded" @delete="deleteFile" />
     <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark >
        <v-card-text>
          {{status}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>  
  </v-layout>  
</template>
<script lang="ts">

  import Vue from 'vue'  
  //@ts-ignore 
  import deepEqual from 'deep-equal'  
  import Component from 'vue-class-component'
  import sortBy from 'lodash/sortBy'
  import types from '@/store/all-mutation-types'
  import { Watch} from 'vue-property-decorator'  
  import {buildDataMissionKey, DataPoolMissionKeys} from '@/enum/DataPool'
  import { GliderFileType } from '@/enum/GliderFileType'
  import { ICoriolisConfig,getDefaultCoriolisConfig } from '@/models/iris/coriolis/ICoriolisConfig'
  import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
  import { AloGliderFileShort } from '../../models/alo/AloGliderFileShort'
  import apiHelpers from '@/utils/api'
  import mission from '../../api/mission';
  import { SecurityItemsKeys } from '../../enum/SecurityItems';
  import { VuetifyConfirmObject } from 'vuetify-confirm'
  import MissionDetailFileUpload from '@/components/mission/MissionDetailFileUpload.vue'

@Component({
    name: 'MissionDetailCoriolis',
    components:{MissionDetailFileUpload}    
  })
  export default class MissionDetailFileTransfer extends Vue {  
   
    
    config = {
      enableCoriolis : true,
      ...getDefaultCoriolisConfig()
    }   

    private runDisbled = false
    
    get currentDetailMission(){
      return this.$store.myGetters.currentDetailMission
    }

    get btnRunDisable(){
      return this.loading || !this.config.enableCoriolis || this.runDisbled
    }

    get btnActif() {
      const config = {}      
      this.loadConfig(config,this.originalCoriolisConfig)      
      return this.config.enableCoriolis && !deepEqual(config,this.config) && !this.loading
    }

    get autoExportEnable() {
      return this.config.Coriolis_Export.automatic_export
    }

    set autoExportEnable(value) {
      this.config.Coriolis_Export.automatic_export = value
    }

    get fileList() {
      return this.config.Coriolis_Export.file_list
    }

    get lastExport() {
      return this.config.Coriolis_Export.last_export
    }

    get loading(){
      return this.$store.myGetters.coriolisLoading
    }

    get status(){
      return this.$store.myGetters.missionStatus
    }    

    created() {                                 
      if(this.mission.misId != null) this.$store.myActions.MISSION_IRIS_CORIOLIS_REQUEST(this.mission.misId!).then(() => {
         this.loadConfig(this.config,this.modifiedCoriolisConfig)          
      })                 
    }  

    mounted() {
      
    }


    get mission() {
        return this.currentDetailMission.mission
    }        
    
    get originalCoriolisConfig() {
      return this.$store.myGetters.originalCoriolisConfigs[this.mission.misId!]
    }         

    get modifiedCoriolisConfig() {
      return this.$store.myGetters.modifiedCoriolisConfigs[this.mission.misId!]
    } 

    @Watch('mission')
    onMissionChanged(newValue: any) {                        
      if(newValue.misId != null) this.$store.myActions.MISSION_IRIS_CORIOLIS_REQUEST(newValue.misId)      
    }
    
    @Watch('modifiedCoriolisConfig')
    onModifiedCoriolisChanged(newConfig: IrisConfigContainer<ICoriolisConfig>, oldConfig: IrisConfigContainer<ICoriolisConfig>) {            
      this.loadConfig(this.config,newConfig)      
    }

    @Watch('config', { deep: true })
    onConfigChanged(newConfig: any) {              
       this.validateConfig()
    }

    loadConfig(target:any,config:IrisConfigContainer<ICoriolisConfig>){
      if(config) {       
        target.enableCoriolis = config.mod_settings.EnabledMOD['module-Coriolis'],
        target.EnabledMOD = {...config.mod_settings.EnabledMOD},
        target.Coriolis_Export = {...config.mod_settings.Coriolis_Export,
        file_list:Array.isArray(config.mod_settings.Coriolis_Export.file_list)?config.mod_settings.Coriolis_Export.file_list
        //@ts-ignore
        :(config.mod_settings.Coriolis_Export.file_list && (config.mod_settings.Coriolis_Export.file_list?.length ?? 0) > 0)?[config.mod_settings.Coriolis_Export.file_list]:[]}
      }
    }

    validateConfig() {      
      this.$store.myActions.MISSION_UPDATE_MODIFIED_CORIOLIS({
        itemId:this.mission.misId!,
        newProperties: {
          mod_settings:{
            EnabledMOD:{              
              'module-Coriolis': this.config.enableCoriolis
            },
            Coriolis_Export:{
              ...this.config.Coriolis_Export
            }
          }
        } 
      })
    }

    saveConfig() {      
      this.validateConfig()
      this.$store.myActions.MISSION_IRIS_CORIOLIS_SAVE_REQUEST(this.mission.misId!)      
    }

    restoreConfig() {
      this.$store.myActions.MISSION_CANCEL_MODIFIED_CORIOLIS(this.mission.misId!)
    }

    restoreDefault() {
      this.config = {
        enableCoriolis: true, 
        ...getDefaultCoriolisConfig()
      }
    }

    run() {
      this.runDisbled = true      
      this.$store.myActions.MISSION_IRIS_CORIOLIS_RUN_REQUEST(this.mission.misId!)
      //on desactive le bouton au moins 15s
      setTimeout(() => {
        this.runDisbled = false
      }, 15000);
    }

    downloadFile(url:string) {   
      apiHelpers.downloadFile(url)
    }   

    downloadCoriolisFile(file:string) {   
      apiHelpers.downloadFile(`/api/iris/coriolis/${this.mission.misId!}/file/${file}`)
    }   

    uploaded(file:string) {      
      if(this.fileList.indexOf(file) == -1){
        this.fileList.push(file)        
      }
    }

    allUploaded(){
      this.saveConfig()
    }

    deleteFile(file:string) {          
      const idx = this.fileList.indexOf(file)
      if(idx > -1){
        this.fileList.splice(idx,1)
        this.saveConfig()
      }
    }

  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
  .subheading,.body-2{
    font-weight: bold;  
  }

  .disable{
    position:relative;
  }

  .disable::before{
    position: absolute;
    content: '';
    left:0px;
    top:0px;
    right:0px;
    bottom:0px;
    background-color: rgba(0,0,0,0.3);
    z-index: 1;
  }

</style>
